import React from 'react';
import style from './Carousal.module.css';
import Image from './Image';
const SlideItem = ({ slide }) => {
  return (
    <div className="item">
      <Image src={slide.link} alt={''} message={''} />
      {/* <img className={style.Image} src={slide.link} alt="" height={100} width="100%" /> */}
      <h4 className={style.titleMsg}>{slide.title}</h4>
      <p className={style.descMsg}>{slide.description}</p>
      {slide?.choices.map((item, index) => (
        <div key={index}>
          {item.text && (
            <>
              <div className={style.cardChoice}>
                <p>{item.text}</p>
              </div>
            </>
          )}
          {item.url && (
            <>
              <div className={style.cardUrlMsg}>
                <span>
                  <img src="./images/linkLogo.png" alt="" width={12} height={12} />
                </span>
                <a
                  className={style.cardUrlSpanMsg}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer">
                  {item.url}
                </a>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default SlideItem;
